var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"add-and-attach-target-row"},[_c('span',{staticClass:"add-and-attach-target-row__label"},[_vm._v("Attaching to "+_vm._s(_vm.targetTypeLabel)+":")]),_c('span',{staticClass:"add-and-attach-target-row__value"},[_vm._v("#"+_vm._s(_vm.code)+" "+_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }